import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    errorStatus: 'A correction is required among the beneficial owners.',
    errorTag: 'Action required',
    pendingStatus:
      'All beneficial owners must **complete their personal information** and send us a **proof of identity** via the invitation sent to them by e-mail.',
    pendingTag: 'Pending verification',
    verifyingStatus:
      'We will take charge of your file and check all the supporting documents.\nWe usually get back to you within 48 working hours.',
    verifyingTag: 'Under verification',
  },
  fr: {
    errorStatus:
      'Une correction est nécessaire parmi les bénéficiaires effectifs.',
    errorTag: 'Action requise',
    pendingStatus:
      'Tous les bénéficiaires effectifs doivent **compléter leurs informations personnelles** et nous transmettre un **justificatif d’identité** via l’invitation qui leur a été envoyée par e-mail.',
    pendingTag: 'En attente de vérification',
    verifyingStatus:
      'Nous allons prendre en charge votre dossier et vérifier toutes les pièces justificatives.\n Nous revenons généralement vers vous dans les 48h ouvrées.',
    verifyingTag: 'En cours de vérification',
  },
} as const);
